
<div class="document-value-box">
    <div class="document-value">
        <span
            class="document-value__label"
            data-testid="document-value-box-label">
            {{ 'scenes.shared.control.document-value-box.label' | translate }}:
        </span>
        <a
            data-testid="document-value-box-value"
            class="document-value__value link link--dotted"
            (click)="click()"
        >
            <div>{{ value() }}</div>
            <div><ng-content /></div>
        </a>
    </div>
    @if (displayVatTable()) {
        <div
            class="document-vat-table"
            data-testid="document-value-box-icon"
            (click)="click()"
        >
            <div class="vat-table-icon">
                <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="M8 8H16M16 12H8M8 16H12M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <span class="vat-table-label">{{ 'scenes.shared.control.document-value-box.show-vat-table' | translate }}</span>
        </div>
    }
</div>